import React from 'react';
import size from 'lodash/size';
import { Alert, Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
import PropTypes from 'prop-types';

// Use case example: yield put(setAlertScreenMessage(ALERT_TYPE.warning, 'some message', 'some title', true, ACTIVE_SCREEN_KEY));

const AlertNotification = props => {
    const { alertData, removeAlertScreenMessage } = props;
    const { type = 'info', title, message, width = 'long', positionSticky = true } = alertData;

    const theme = useTheme();
    const getWidth = widthValue => {
        if (widthValue === 'short') return 'auto';
        return '-webkit-fill-available';
    };

    const alertStyles = {
        position: positionSticky ? 'sticky' : 'relative',
        width: getWidth(width),
        marginLeft: '0',
        marginRight: 'auto',
        marginBottom: '7px',
        color: theme.palette.text.primary,
        borderRadius: '6px',
        borderLeftWidth: '4px',
        borderTop: '0',
        borderBottom: '0',
        borderRight: '0',
        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 8px 0px',
        textAlign: 'left',
    };

    const isMultipleMessage = Array.isArray(message);

    const closeAlert = () => {
        removeAlertScreenMessage();
    };

    if (size(type) && size(message))
        return (
            <Alert
                contrast="normal"
                severity={type}
                sx={alertStyles}
                onClose={() => closeAlert()}
                iconMapping={{
                    success: <CheckCircleIcon />,
                    info: <InfoIcon />,
                    warning: <WarningIcon />,
                    error: <ErrorIcon />,
                }}>
                <Box display={width === 'short' ? 'flex' : 'block'} marginTop="-3px">
                    <Typography variant="body1" fontWeight={600} marginRight={width === 'short' ? '6px' : '0px'}>
                        {title}
                    </Typography>
                    {isMultipleMessage ? (
                        message.map(item => <Typography>{item}</Typography>)
                    ) : (
                        <Typography>{message}</Typography>
                    )}
                </Box>
            </Alert>
        );
    return false;
};

AlertNotification.propTypes = {
    alertData: PropTypes.shape({
        type: PropTypes.string.isRequired,
        message: PropTypes.string.isRequired,
        title: PropTypes.string,
        positionSticky: PropTypes.bool,
        width: PropTypes.string,
    }).isRequired,
    removeAlertScreenMessage: PropTypes.func.isRequired,
};
export default AlertNotification;
